import React from 'react';
import LayoutProvider from '../../Contexts/LayoutProvider';
import LibModal from '../../features/LibModal/LibModal';
import { useTemplate } from '../../features/template/TemplateProvider';
import ApiAccessKeyProvider, { useApiAccessToken } from './ApiAccessTokenProvider';
import ApiAccessTokenBody from './components/ApiAccessTokenBody';
import ApiAccessTokenBodyMobile from './components/ApiAccessTokenBodyMobile';
import ApiAccessKeyHeader from './components/ApiAccessTokenHeader';
import ApiAccessTokenHeaderMobile from './components/ApiAccessTokenHeaderMobile';
import CreateNewAccessTokenModal from './modal/CreateNewAccessTokenModal';
import ShowGeneratedTokenModal from './modal/ShowGeneratedTokenModal';

function PageCont() {
    const { modalType, closeModal } = useTemplate();
    const { handleReload } = useApiAccessToken();

    return (
        <div className="access_key_page inner_page_cont">
            <LayoutProvider>
                <ApiAccessKeyHeader handleReload={handleReload} layout="default" />
                <ApiAccessTokenHeaderMobile layout={['md', 'sm', 'xs', 'xxs']} />
            </LayoutProvider>
            <LayoutProvider>
                <ApiAccessTokenBody layout="default" />
                <ApiAccessTokenBodyMobile layout={['md', 'sm', 'xs', 'xxs']} />
            </LayoutProvider>

            {/* Generate new access token */}
            {modalType === 'create-new-access-token' ? (
                <LibModal title="Create New Token" setOpen={closeModal}>
                    <CreateNewAccessTokenModal />
                </LibModal>
            ) : null}

            {/* Show Generated access token */}
            {modalType === 'show-generated-access-token' ? (
                <LibModal title="Generated Token" setOpen={closeModal}>
                    <ShowGeneratedTokenModal />
                </LibModal>
            ) : null}
        </div>
    );
}

function ApiAccessTokenPage() {
    return (
        <ApiAccessKeyProvider>
            <PageCont />
        </ApiAccessKeyProvider>
    );
}

export default ApiAccessTokenPage;
